import { createErrorNotification, createSuccessNotification, } from "../toaster/creators";
import { addNotification } from "../toaster/actions";
import { Observable } from "rxjs";
const successNotification = createSuccessNotification("File archived correctly");
const errorNotification = createErrorNotification("Could not archive file");
export function createNotificationOnCreateEpic(actionKeys) {
    return (actions$) => actions$
        .ofType(actionKeys.FINISH)
        .mergeMap(() => Observable.of(addNotification(successNotification)));
}
export function createNotificationOnCreateErrorEpic(actionKeys) {
    return (actions$) => actions$
        .ofType(actionKeys.ERROR)
        .mergeMap(() => Observable.of(addNotification(errorNotification)));
}
//# sourceMappingURL=updateNotification.js.map